module.exports = __webpack_public_path__ + "img/iPhone6-4.7.125303e5.png";